export function firstnameValidator(firstName) {
  if (!firstName) return "First Name can't be empty.";
  return "";
}
export function lastnameValidator(lastName) {
  if (!lastName) return "Last Name can't be empty.";
  return "";
}

